import Vue from 'vue'
import App from './app.vue'
import 'babel-polyfill'

require('../../assets/styles/public.min.css')

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/views/contact/index.js